import { createFormState, required } from 'redux-freeform';

const formConfig = {
  location: {
    validators: [required()],
  },
  terminal: {
    validators: [required()],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);
